import * as React from 'react';

interface ITabNameProps {
  isActive?: boolean;
  onClick?: (e: React.MouseEvent<HTMLElement>) => void;
}

interface ITabNameState {}

export default class TabName extends React.Component<ITabNameProps, ITabNameState> {
  render() {
    return (
      <div onClick={this.props.onClick} className={`tab-name ${this.props.isActive ? 'tab-name--active' : ''}`}>
        {this.props.children}
      </div>
    );
  }
}
